//import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { IChatRequest } from "../interfaces/chatBotInterfaces";
import { IChatBotApi } from "../interfaces/apiInterface";

export class ChatBotApi implements IChatBotApi {
  //public readonly axios: AxiosInstance;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(private api: any) {
    //logEvent(`Initializing`, "UnifiedPortalAPI", this.upEndpoint);
    // this.axios = axios.create({
    //   withCredentials: true,
    //   withXSRFToken: false,
    //   allowAbsoluteUrls: false,
    // });
  }

  // private send = async <T = any>(request: AxiosRequestConfig) => {
  //   return this.axios.request<T>(request);
  // };

  // public ask(request: IChatRequest) {
  //   return this.send({
  //     method: "POST",
  //     url: `${this.apiURL}/api/v1/chat`,
  //     data: request,
  //   } as AxiosRequestConfig);
  // }

  public async ask(request: IChatRequest) {
    return await this.api.ask(request);
  }
}
